import $ from "jquery";
import fslightbox from "fslightbox";

const photoGallery = () => {
  $(window).on("load", () => {
    fslightbox;
  });
};

try {
  photoGallery();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
